import { Rect } from "./types";
import { rectsIntersect } from "./utils";

interface Block {
  rect: Rect;
  alive: boolean;
}

export class Bunker {
  private blocks: Block[] = [];
  private readonly color: string;

  /**
   * `shape` is per-instance rather than read from config, so a bunker can be
   * the classic silhouette or a single letter of a word.
   */
  constructor(
    originX: number,
    originY: number,
    shape: number[][],
    blockSize: number,
    color: string
  ) {
    this.color = color;
    for (let r = 0; r < shape.length; r++) {
      for (let c = 0; c < shape[r].length; c++) {
        if (!shape[r][c]) continue;
        this.blocks.push({
          rect: {
            x: originX + c * blockSize,
            y: originY + r * blockSize,
            width: blockSize,
            height: blockSize,
          },
          alive: true,
        });
      }
    }
  }

  /** Destroys the first live block intersecting `rect`. Returns true on hit. */
  hit(rect: Rect): boolean {
    for (const block of this.blocks) {
      if (block.alive && rectsIntersect(block.rect, rect)) {
        block.alive = false;
        return true;
      }
    }
    return false;
  }

  draw(ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = this.color;
    for (const block of this.blocks) {
      if (block.alive) {
        ctx.fillRect(block.rect.x, block.rect.y, block.rect.width, block.rect.height);
      }
    }
  }
}
